import React from 'react';
import style from './login-advertise-slider.module.css';

import { Link } from "react-router-dom";

const LoginAdvertiseSlider = ({
  bg_color,
  logo_link,
  school_name,
  heading_color,
  phone_number,
  avatar_pic_link,
}) => {
  const styles = {
    background_color: { backgroundColor: bg_color },
    h3_styles: { color: heading_color },
  };

  return (
    <div
      className={style.sample_school_advert_on_login}
      style={styles.background_color}
    >
      <div className={style.sample_school_advert_on_login__left}>
        <div className={style.logo_and_name}>
          <span className={style.logo} >
            <img src={logo_link} alt={logo_link} />
          </span>
          <span className={style.name}>{school_name}</span>
        </div>
        <div className={style.middle}>
          <h2 style={styles.h3_styles}>UNIVERSITY ADMISSION</h2>
          <h3>{`Open for ${new Date().getFullYear()}`}</h3>
          <p>Best university for your child...</p>
        </div>
        <div className={style.bottom}>
          <div className={style.bottom__left}></div>
          <div className={style.bottom__right}>
            <p className={style.for_more_info}>For more information</p>
            <Link to={`tel:${phone_number}`}>{phone_number}</Link>
          </div>
        </div>
      </div>
      <div className={style.sample_school_advert_on_login__right}>
        <div className={style.avatar_main_container}>
          <div className={style.avatar_inner_container}>
            <img src={avatar_pic_link} alt={avatar_pic_link} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginAdvertiseSlider;

